import { Router } from '@angular/router';
import { Component,ViewChild, OnInit } from '@angular/core';
import { HttpclientService } from '../../services/httpclient.service';
import { Useradmindto } from '../../model/useradmindto';
import { Updateuser } from '../../model/updateuser';
import { Usertypeandaccessdto } from '../../model/usertypeandaccessdto';
import { ConfirmDialogService } from '../../services/confirm-dialog.service';
import { PoOrderByPipe } from './../../pipes/po-order-by.pipe';
import { NgForm, FormGroup, FormControl, FormBuilder } from '@angular/forms';
declare var $: any;
@Component({
  selector: 'app-user-admin',
  templateUrl: './user-admin.component.html',
  styleUrls: ['./user-admin.component.css']
})
export class UserAdminComponent implements OnInit {
  formChanged : boolean = false;
  @ViewChild("myForm") ngForm: NgForm;
  @ViewChild("contactForm",null) contactForm:NgForm;
  checkUserUpdated : string = "";
  msg : string = "User Is Successfully Updated";
  selectControl : string = "";
  selectedloc : any[] = [];
   firstname1 : string = "";
  useradmindtolist :Useradmindto[];
  intialPurchaseOrderListClonned:Useradmindto[];
  loading : boolean;
  selectPartenerLocations: any[] = [];
  seltype1:string = "";
  createuseradmin : boolean ;
  usernametitle:string;
  updateduser : boolean ;
  firstname : string ="";
  firstnm: string = "";
  lastnm: string = "";
  emailadrs: string = "";
  usertyp : number ;
  pss : string;
  cpss:string;
  statuss: boolean ;
  selectedpl: any[] = [];
  teststr : string ="Testing";
  lastname : string ;
  usertype : number ;
  access : string ; 
  username : string ;
  status : string ;
  userId : number;
  isuserupdated : string="";
  usertypeandaccessdto : Usertypeandaccessdto;
  roleList : Role[];
  copyRoleList : Role[];
  partnerList : Partner[];
  roleId : number;
  rolId ;
  isStatus : boolean;
  password : string;
  confpassword : string;
  searchAdminUserInputCheckMessage : string = "";
  cloneuseradmindtolist : Useradmindto[];
  modalPopup : boolean=false;
  modalLocPopup : boolean=false;
  location_name="";
  data;
  distributorSavedLocation=[];
  updateLocationList = [];
  filterUpdateLocationList = [];
  updatedSelectedLocations = [    
  ];

  selectedlocations: any = [];  
  statusvalues: string[] = ['Active','Inactive' ];
  filterTypeList:any = [];
  filterAccessList:any = [];
  selectedType: string = "";
  selectedAccess: string = "";
  selectedStatus: string = "";
  filteredUseradmindtolist :Useradmindto[];
  locationDataSize: number;
  isSavedMovedLocation: boolean;
  locationModalPopup : boolean = false;
  previousLocationDataSize: number = 0;
  selectedPayerToLoad: string = "";
  isSelectionListEmpty : boolean=false;
  
  isFirstNameSortCollapsedUpArrow : boolean;
  isFirstNameSortCollapsedDownArrow  : boolean;
  isLastNameSortCollapsedUpArrow  : boolean;
  isLastNameSortCollapsedDownArrow  : boolean;
  isTypeSortCollapsedUpArrow  : boolean;
  isTypeSortCollapsedDownArrow  : boolean;
  isAccessSortCollapsedUpArrow  : boolean;
  isAccessSortCollapsedDownArrow  : boolean;
  isUserNameSortCollapsedUpArrow  : boolean;
  isUserNameSortCollapsedDownArrow  : boolean;
  isStatusSortCollapsedUpArrow  : boolean;
  isStatusSortCollapsedDownArrow  : boolean;
  isDistributor : boolean;
  modalDisPayerPopup : boolean = false;
  isPayerSelectValFail : boolean = false;
 public intialPurchaseOrderList :Useradmindto[];

  constructor(private httpclientService : HttpclientService, private router : Router, private confirmDialogService: ConfirmDialogService,private pipe: PoOrderByPipe,) {
    this.createuseradmin=false;
    this.updateduser = false;
    this.initialSortValue();
    this.isDistributor = sessionStorage.getItem('roleId')=='6' ? true : false;
   }

  ngOnInit() {
    $(document).ready(
      // console.log("PoCOMp")
      () => {
    let searchInp = $(".searchContr .searchInput");
    let searchCloseIcon = $(".searchCloseIcon")
    $(searchInp).on("focus", function () {
      $(".searchIcon").addClass("searchIconActive")
      $(".searchCloseIcon").fadeIn("slow")
    })
    $(searchInp).on("blur", function () {
      $(".searchIcon").removeClass("searchIconActive")
      $(".searchCloseIcon").fadeOut("slow")
    })
    $(searchCloseIcon).hover(function () {
      $(searchCloseIcon).toggleClass("searchCloseIconFocus")
    })
    $(searchCloseIcon).on("click", function () {
      $(".searchContr input").val("");

    })
  });    
    this.getuseradmin();
    //this.getusertypeNaccess();
  }
  getuseradmin(){    
    this.loading=true;  
    this.filterTypeList = [];  
    this.httpclientService.getuseradmin().subscribe(
      data =>{
          this.useradmindtolist = data;

          this.filteredUseradmindtolist =  data;
          
          var len = this.useradmindtolist.length;
          for(var i=0;i<len;i++){
           var type = this.useradmindtolist[i].type;
           this.useradmindtolist[i].type = type[0].toUpperCase() + type.slice(1);
          }
          this.intialPurchaseOrderListClonned = this.useradmindtolist;
          console.log(this.useradmindtolist);
          this.intialPurchaseOrderList= data;
          this.loading=false;     
          
          //this.filterTypeList = this.useradmindtolist.map(item => item.type).filter((value, index, self) => self.indexOf(value) === index).filter(function (e) {return e != null;}).sort(function (a, b) {
          //  return a.localeCompare(b);
          //});
       
          this.filterTypeList = this.useradmindtolist.sort(function (a, b) {
            return a.type.localeCompare(b.type);
          });
  
          const sortOn = (prop, list) => {
            const order = list.reduce((obj, key, idx) => Object.assign(obj, { [key]: idx + 1}), {});
            const getVal = item => order[item[prop]] || Infinity
            
            return (a, b) => getVal(a) - getVal(b)
          }
          
          this.filterTypeList.sort(sortOn('type', ["Admin", "Axalta Admin", "Axalta CSR", "Distributor", "Customer"]))

          this.filterTypeList = this.filterTypeList.reduce((acc, current) => {
            const x = acc.find(item => item.type === current.type);
            if (!x) {
              return acc.concat([current]);
            } else {
              return acc;
            }
          }, []);

          
          this.filterAccessList = this.useradmindtolist.map(item => item.partnerName).filter((value, index, self) => self.indexOf(value) === index).filter(function (e) {return e != null;}).sort(function (a, b) {
            return a.localeCompare(b);
          });          
      }               
  )  
  }
  
  createuser(){    
    this.createuseradmin=true;    
  }
  enablingupdate(useradmindto){
    this.selectedlocations = [];
    this.data = [];
    this.isuserupdated='';
    this.getusertypeNaccess();
    this.isValidatedFields="";
    this.updateduser=true;
    this.searchAdminUserInputCheckMessage="";
    this.firstname =useradmindto.firstName;
    this.firstnm = this.firstname;
    this.lastname = useradmindto.lastName;
    this.lastnm = this.lastname;
    this.usertype = useradmindto.type[0].toUpperCase() + useradmindto.type.slice(1);
    this.usertyp = this.usertype;
    this.access = useradmindto.access;
    this.username = useradmindto.userName;
    this.emailadrs = this.username;
    this.usernametitle=useradmindto.userName;
    this.isStatus = useradmindto.status;
    this.statuss = this.isStatus;
    this.userId = useradmindto.userId;
    this.roleId = useradmindto.roleId;
    this.rolId = this.roleId;
    this.password=useradmindto.password;    
    this.pss = this.password;  
    this.confpassword=useradmindto.password;        
    this.cpss = this.confpassword;       
    this.getDistributorLocationDetails();    
    this.teststr = "This_is_set";    
  }
  // isEmailValid:boolean=false;
  // checkingEmail(email){
  //   var emailCheck = email.value;
  //   var isEmailValid="^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$";
  //   if(!emailCheck.match(isEmailValid)){
  //     this.isEmailValid=true;
  //   }else{
  //     this.isEmailValid=false;
  //   }
  // }

  validatePayerForDistributor()
  {
    this.modalDisPayerPopup = false;
    this.isPayerSelectValFail = true;
  }

  validateBeforeSave(password,confpassword)
  {       
    this.copyRoleList = this.roleList.filter(item => item.roleType == 'Distributor');
    
    if(this.roleId == this.copyRoleList[0].roleId)
    {      
      if(this.access == null || this.access == '')
      {
        this.modalDisPayerPopup = true;               
      } 
      else
      {
        this.isPayerSelectValFail = false;
        this.updateuser(password,confpassword);                    
      }
    }
    else
    {
      this.isPayerSelectValFail = false;
      this.updateuser(password,confpassword);  
    }
  }

  updateuser(password,confpassword){     
    this.isuserupdated="";
    this.isValidatedFields=""
    if(this.firstname == "" || this.firstname== null || this.firstname== undefined ){
      this.isuserupdated="Please Enter First Name";
      this.isValidatedFields="All Mandatory Fields Need to be Filled. Please Check Details Below.";
      return ;
    }
    if(this.username=="" || this.username== null || this.username== undefined  ){
      this.isuserupdated="Please Enter Email Address";
      this.isValidatedFields="All Mandatory Fields Need to be Filled. Please Check Details Below.";
      return ;
    }
    if(!this.username.includes("@")){
      this.isuserupdated="Please Enter Email Address In Proper Format";
      this.isValidatedFields="All Mandatory Fields Need to be Filled. Please Check Details Below.";
      return;
    }
    if(!this.username.includes(".")){
      this.isuserupdated="Please Enter Email Address In Proper Format";
      this.isValidatedFields="All Mandatory Fields Need to be Filled. Please Check Details Below.";
      return;
    }
    if(this.username.includes(".") && this.username.includes("@")){
     var pos1  =  this.username.lastIndexOf("@")+3; 
      var pos2 = this.username.lastIndexOf(".")
      var size = this.username.length-1;
      if(pos2 < pos1){
      this.isuserupdated="Please Enter Email Address In Proper Format";
      this.isValidatedFields="All Mandatory Fields Need to be Filled. Please Check Details Below.";
      return;
      }
      if(size <= pos2){
        this.isuserupdated="Please Enter Email Address In Proper Format";
        this.isValidatedFields="All Mandatory Fields Need to be Filled. Please Check Details Below.";
        return;
      }
    }
    let roleidstr = ''+ this.roleId;
    if(roleidstr == "" || roleidstr == null || roleidstr == undefined){
      this.isuserupdated="Please Enter User Type";
      this.isValidatedFields="All Mandatory Fields Need to be Filled. Please Check Details Below.";
      return ;
    }
    if(roleidstr=="3" && (this.access=="" || this.access== null || this.access== undefined)){
      this.isuserupdated="Please Enter Access";
      this.isValidatedFields="All Mandatory Fields Need to be Filled. Please Check Details Below.";
      return ;
    }
    
    
    if(this.selectedPayerToLoad == '')
    {
      
      if(password.value == "" || password.value == undefined || password.value == null){
        this.passwordCheck="Please Enter Password";
        this.isValidatedFields="All Mandatory Fields Need to be Filled. Please Check Details Below.";
        return ;
      }
      if(password.value.length < 8 ){
        this.passwordCheck="The Password must be of minimum 8 characters length";
        this.isValidatedFields="All Mandatory Fields Need to be Filled. Please Check Details Below.";
        return ;
      }
      if(confpassword.value == "" || confpassword.value == undefined || confpassword.value == null){
        this.confPassCheck="Please Enter Confirm Password";
        this.isValidatedFields="All Mandatory Fields Need to be Filled. Please Check Details Below.";
        return ;
      }
      if(confpassword.value.length < 8 ){
        this.confPassCheck="The Confirm Password must be of minimum 8 characters length";
        this.isValidatedFields="All Mandatory Fields Need to be Filled. Please Check Details Below.";
        return ;
      }
      if(password.value != confpassword.value){
        this.isEqualPassNconfPass="Password and Confirm Password must match";
        this.isValidatedFields="All Mandatory Fields Need to be Filled. Please Check Details Below.";
        return ;
      }          
    }
    else
    {      
      if(password == "" || password == undefined || password == null){
        this.passwordCheck="Please Enter Password";
        this.isValidatedFields="All Mandatory Fields Need to be Filled. Please Check Details Below.";
        return ;
      }
      if(password.length < 8 ){
        this.passwordCheck="The Password must be of minimum 8 characters length";
        this.isValidatedFields="All Mandatory Fields Need to be Filled. Please Check Details Below.";
        return ;
      }
      if(confpassword == "" || confpassword == undefined || confpassword == null){
        this.confPassCheck="Please Enter Confirm Password";
        this.isValidatedFields="All Mandatory Fields Need to be Filled. Please Check Details Below.";
        return ;
      }
      if(confpassword.length < 8 ){
        this.confPassCheck="The Confirm Password must be of minimum 8 characters length";
        this.isValidatedFields="All Mandatory Fields Need to be Filled. Please Check Details Below.";
        return ;
      }
      if(password != confpassword){
        this.isEqualPassNconfPass="Password and Confirm Password must match";
        this.isValidatedFields="All Mandatory Fields Need to be Filled. Please Check Details Below.";
        return ;
      }      
    }
    

    
    if(this.selectedPayerToLoad === '')
    {
      let updatinguser : Updateuser = new Updateuser(this.firstname,this.lastname,this.roleId,this.access,this.username,this.isStatus,this.userId,this.roleId,password.value,confpassword.value,this.teststr,this.selectedlocations);
      this.loading=true;
      this.httpclientService.getupdateuser(updatinguser).subscribe(
      data =>{
        this.isuserupdated=data.isSaved;
        this.checkUserUpdated = data.isSaved;
        this.loading=false;
        var cc = this.checkUserUpdated.replace(/\s/g, "");
        var cc1 = this.msg.replace(/\s/g, "");
       // console.log("cccc2" +cc + "cccc1" + cc1);
        
        
        if(cc == cc1){
        
        //alert("User Is Successfully Updated");
          this.firstnm = this.firstname;
          this.lastnm = this.lastname;
          this.emailadrs = this.username;
          this.rolId = this.roleId;
          this.cpss = this.confpassword;
          this.selectedloc = this.selectedlocations;
        }
        cc == "";
       
      }
     )
     this.previousLocationDataSize = this.data.length; 
    }
    else
    {
      let updatinguser : Updateuser = new Updateuser(this.firstname,this.lastname,this.roleId,this.access,this.username,this.isStatus,this.userId,this.roleId,password,confpassword,this.teststr,this.selectedlocations);
      this.loading=true;
      this.httpclientService.getupdateuser(updatinguser).subscribe(
      data =>{
        this.isuserupdated=data.isSaved;
        this.loading=false;
        this.checkUserUpdated = data.isSaved;
        var cc = this.checkUserUpdated.replace(/\s/g, "");
        var cc1 = this.msg.replace(/\s/g, "");
     //console.log( "cccc"+ cc + "cccc" + cc1);
        if(cc == cc1){
            this.firstnm = this.firstname;
            this.lastnm = this.lastname;
            this.emailadrs = this.username;
            this.rolId = this.roleId;
            this.cpss = this.confpassword;
            this.selectedloc = this.selectedlocations;
           
            //alert("User Is Successfully Updated...");
        }
       
      }
     )
     this.previousLocationDataSize = this.data.length; 
    }    
  }
  passwordCheck :string="";
  confPassCheck :string="";
  isEqualPassNconfPass : string="";
  isValidatedFields="";
  clearField(){
    this.isuserupdated="";
    this.passwordCheck ="";
    this.confPassCheck ="";
    this.isEqualPassNconfPass ="";
    this.isValidatedFields="";
    this.isValidatedFields="";            
  }

  valdUserPayerType()
  {
    this.copyRoleList = this.roleList.filter(item => item.roleType == 'Distributor');
    
    if(this.roleId == this.copyRoleList[0].roleId)
    {      
      if(this.access == null || this.access == '')
      {
        this.isPayerSelectValFail = true;
      }
      else
      {
        this.isPayerSelectValFail = false;
      }
    }
    else
    {
      this.isPayerSelectValFail = false;
    }
  }

  
  showDialog() { 
    this.isuserupdated=""; 
    this.confirmDialogService.confirmThis("Are you sure You want to Cancel?", function () {  
      this.updateduser = false;
      this.getuseradmin();
    }, function () {  
       
    })  
  } 
  checkValue(values:any){
    console.log(values.currentTarget.checked);
    this.isStatus=values.currentTarget.checked;
    
 }
  pressingOK(){
    this.isSelectionListEmpty = false;
    this.modalPopup=false;
    this.updateduser = false;
    this.selectedloc = [];
    this.getuseradmin();
    this.previousLocationDataSize = this.data.length;     
  }

  locationOK(){    
    this.isSelectionListEmpty = false;
    this.updateuser(this.password,this.confpassword);    
    this.previousLocationDataSize = this.data.length; 
    this.selectLocationChangeHandler(this.selectedPayerToLoad);
    this.isSavedMovedLocation=false;
    this.locationModalPopup=false;      
  }

  locationCancel(){    
    this.isSelectionListEmpty = true;  
    this.previousLocationDataSize = this.data.length; 
    //this.selectLocationChangeHandler(this.selectedPayerToLoad);
    this.getDistributorLocationDetails();
    this.isSavedMovedLocation=false;
    this.locationModalPopup=false;      
  }

  pressingLocationModalOK()
  {
    this.modalLocPopup =  false;
  }

  pressingCancel(){
    this.modalPopup=false;
  }
  cancelUpdate(){
    this.isuserupdated="";
    var count = 0;
    var islocEqual = false;
    
    //this.modalPopup=true;
    if(this.firstname === this.firstnm && this.lastname === this.lastnm && this.username === this.emailadrs 
      && this.roleId == this.rolId &&  this.confpassword == this.cpss){
     
     
      // console.log("!!!!!!!!" + this.firstnm + "!!!!!!!!" + this.firstname + "!!!!!!!!" + this.firstname === this.firstnm);
      // console.log("!!!!!!!!" + this.lastname + "!!!!!!!!" +this.lastnm + "!!!!!!!!" + this.lastname === this.lastnm);
      // console.log("!!!!!!!!" + this.username + "!!!!!!!!" + this.emailadrs + "!!!!!!!!" + this.username === this.emailadrs);
      // console.log("!!!!!!!!" + this.usertype + "!!!!!!!!" + this.usertyp + "!!!!!!!!" );
      // console.log("!!!!!!!!" + this.password + "!!!!!!!!" + this.pss+ "!!!!!!!!" );
      // console.log("!!!!!!!!" + this.confpassword + "!!!!!!!!" + this.cpss + "!!!!!!!!" + this.confpassword == this.cpss);
      // console.log("!!!!!!!!" + this.roleId + "!!!!!!!!" + this.rolId + "!!!!!!!!" + this.roleId === this.rolId );
      //console.log("<><><>" + this.selType + "<><><>") ;
      var n1 = this.selectedlocations.length;
      var n2 = this.selectedloc.length;
      if(n1 == n2){
        for(let j = 0; j < n1; j++) {
          var dataLocCode1 = this.selectedlocations[j].name;
          var dataCode1 = dataLocCode1.substring(0, dataLocCode1.indexOf("-")-1);
          for(let i = 0; i < n2; i++){    
            var dataLocCode = this.selectedloc[i].name;
            var dataCode = dataLocCode.substring(0, dataLocCode.indexOf("-")-1);
            if(dataCode1 == dataCode ){
              count++;
              break;
            }
          }
        }
        if(count == n1 && count == n2 ){
          islocEqual = true;
        }
        else{
          islocEqual = false;
        }
      }
    if(islocEqual == true){
      this.getuseradmin();
      this.updateduser = false;
      this.selectedloc = [];
    }
    else{
      this.modalPopup=true;
    }

    }
    else{
      this.modalPopup=true;
    }
    //this.ngOnInit();
    // this.showDialog();
    //  if(window.confirm('Click Ok To Confirm')){
    //    this.getuseradmin();
    //    this.updateduser = false;
    //   }
  }

  getusertypeNaccess(){
    this.loading=true;
    this.httpclientService.getusertypeNaccess().subscribe(
      data=>{
        this.usertypeandaccessdto=data;
        var len = this.usertypeandaccessdto.roleList.length;
        for(var i=0;i<len; i++){
          var roleListType = this.usertypeandaccessdto.roleList[i].roleType;
          this.usertypeandaccessdto.roleList[i].roleType = roleListType[0].toUpperCase() + roleListType.slice(1);
          
        }
        
        this.loading=false;
        this.roleList = this.usertypeandaccessdto.roleList.sort(function (a, b) {
          return a.roleType.localeCompare(b.roleType);
        });

        const sortOn = (prop, list) => {
          const order = list.reduce((obj, key, idx) => Object.assign(obj, { [key]: idx + 1}), {});
          const getVal = item => order[item[prop]] || Infinity
          
          return (a, b) => getVal(a) - getVal(b)
        }
        
        this.roleList.sort(sortOn('roleType', ["Admin", "Axalta Admin", "Axalta CSR", "Distributor", "Customer"]))
        
        this.partnerList = this.usertypeandaccessdto.partnerList.sort(function (a, b) {
          return a.partnerType.localeCompare(b.partnerType);
        });
      }
    );   
  }

  filterUserAdmin(searchForUserAdmin){
    this.searchAdminUserInputCheckMessage="";
    if(searchForUserAdmin.value == "" || searchForUserAdmin.value == undefined || searchForUserAdmin.value == null){
      this.searchAdminUserInputCheckMessage = "Please Enter the Search value";
      return;
    }
    var searchAdminUserInput = searchForUserAdmin.value;
    let  filteredRecordForSearchButton: Useradmindto[]=[];
    let searchAdminUserInputCheck = searchAdminUserInput.toLowerCase();
    var  type,partnerName,firstName,lastName,userName;
    for(var useradmindto of this.useradmindtolist ){
      if(useradmindto.type != null && useradmindto.type != undefined && useradmindto.type !=""){
          type =useradmindto.type.toLowerCase();
        }else{
          type="";
        }
      if(useradmindto.partnerName != null && useradmindto.partnerName != undefined && useradmindto.partnerName !=""){
          partnerName = useradmindto.partnerName.toLowerCase();
        }else{
          partnerName="";
        }
      if(useradmindto.firstName != null && useradmindto.firstName != undefined && useradmindto.firstName !=""){
         firstName = useradmindto.firstName.toLowerCase();
        }else{
          firstName="";
        }
      if(useradmindto.lastName != null && useradmindto.lastName != undefined && useradmindto.lastName !=""){
           lastName = useradmindto.lastName.toLowerCase();
        }else{
          lastName="";
        }
      if(useradmindto.userName != null && useradmindto.userName != undefined && useradmindto.userName !=""){
         userName = useradmindto.userName.toLowerCase();
        }else{
          userName="";
        }
         if(firstName.includes(searchAdminUserInputCheck)){
          filteredRecordForSearchButton.push(useradmindto);
        }
        else if(lastName.includes(searchAdminUserInputCheck)){
          filteredRecordForSearchButton.push(useradmindto);
        }
        else if(userName.includes(searchAdminUserInputCheck)){
          filteredRecordForSearchButton.push(useradmindto);
        }
        else if(type.includes(searchAdminUserInputCheck)){
        filteredRecordForSearchButton.push(useradmindto);
      }
      else if(partnerName.includes(searchAdminUserInputCheck)){
        filteredRecordForSearchButton.push(useradmindto);
      }
     
      
      
    }
    let size = filteredRecordForSearchButton.length;
    if(size !=0){
    this.filteredUseradmindtolist=[];
    this.filteredUseradmindtolist=filteredRecordForSearchButton;
    console.log("here >> "+useradmindto);
    }else{
      this.searchAdminUserInputCheckMessage="No Record Found";
      this.filteredUseradmindtolist=this.intialPurchaseOrderList;
    }
    
  }
  clearSearch(){
    
    this.selectedAccess="";
    this.searchAdminUserInputCheckMessage="";
    
    this.filteredUseradmindtolist = this.intialPurchaseOrderListClonned;
    
  }
  clearMessage(){
    this.searchAdminUserInputCheckMessage="";
  }
  
  getSortingDataForUserAdmin(){

  }
  initialSortValue() {
    this.isFirstNameSortCollapsedUpArrow = true;
    this.isFirstNameSortCollapsedDownArrow = true;
    this.isLastNameSortCollapsedUpArrow = true;
    this.isLastNameSortCollapsedDownArrow = true;
    this.isTypeSortCollapsedUpArrow = true;
    this.isTypeSortCollapsedDownArrow = true;
    this.isAccessSortCollapsedUpArrow = true;
    this.isAccessSortCollapsedDownArrow = true;
    this.isUserNameSortCollapsedUpArrow = true;
    this.isUserNameSortCollapsedDownArrow = true;
    this.isStatusSortCollapsedUpArrow = true;
    this.isStatusSortCollapsedDownArrow = true;
    
  }
  sortArry: Useradmindto[];
  onChangeSort(event: any, upDown: boolean, propertyName: string) {
    this.intialPurchaseOrderList = this.useradmindtolist;
    if (propertyName === 'firstName' ) {
      this.isLastNameSortCollapsedUpArrow = true;
      this.isLastNameSortCollapsedDownArrow = true;
      this.isTypeSortCollapsedUpArrow = true;
      this.isTypeSortCollapsedDownArrow = true;
      this.isAccessSortCollapsedUpArrow = true;
      this.isAccessSortCollapsedDownArrow = true;
      this.isUserNameSortCollapsedUpArrow = true;
      this.isUserNameSortCollapsedDownArrow = true;
      this.isStatusSortCollapsedUpArrow = true;
      this.isStatusSortCollapsedDownArrow = true;
      if (upDown) {
    this.sortArry = [];
    this.sortArry = this.pipe.transform(this.intialPurchaseOrderList, propertyName, upDown);
    console.log(this.sortArry[0].firstName);
    this.useradmindtolist = [];
    this.useradmindtolist = this.sortArry;
    this.isFirstNameSortCollapsedUpArrow = !this.isFirstNameSortCollapsedUpArrow;
    this.isFirstNameSortCollapsedDownArrow = true;
} else {
  this.sortArry = [];
  this.sortArry = this.pipe.transform(this.intialPurchaseOrderList, propertyName, upDown);
  console.log(this.sortArry[0].firstName);
  this.useradmindtolist = [];
  this.useradmindtolist = this.sortArry;
  this.isFirstNameSortCollapsedDownArrow = !this.isFirstNameSortCollapsedDownArrow;
  this.isFirstNameSortCollapsedUpArrow = true;
}
  } else if (propertyName === 'lastName' ) {
    this.isFirstNameSortCollapsedUpArrow = true;
    this.isFirstNameSortCollapsedDownArrow = true;
    this.isTypeSortCollapsedUpArrow = true;
    this.isTypeSortCollapsedDownArrow = true;
    this.isAccessSortCollapsedUpArrow = true;
    this.isAccessSortCollapsedDownArrow = true;
    this.isUserNameSortCollapsedUpArrow = true;
    this.isUserNameSortCollapsedDownArrow = true;
    this.isStatusSortCollapsedUpArrow = true;
    this.isStatusSortCollapsedDownArrow = true;
    if (upDown) {
    this.sortArry = [];
    this.sortArry = this.pipe.transform(this.intialPurchaseOrderList, propertyName, true);
    console.log(this.sortArry[0].lastName);
    this.useradmindtolist = [];
    this.useradmindtolist = this.sortArry;
    this.isLastNameSortCollapsedUpArrow = !this.isLastNameSortCollapsedUpArrow;
    this.isLastNameSortCollapsedDownArrow = true;
} else {
  this.sortArry = []; 
  this.sortArry = this.pipe.transform(this.intialPurchaseOrderList, propertyName, false);
  console.log(this.sortArry[0].lastName);
  this.useradmindtolist = [];
  this.useradmindtolist = this.sortArry;
  this.isLastNameSortCollapsedDownArrow = !this.isLastNameSortCollapsedDownArrow;
  this.isLastNameSortCollapsedUpArrow = true;
} 
  }else if (propertyName === 'type' ) {
    this.isFirstNameSortCollapsedUpArrow = true;
    this.isFirstNameSortCollapsedDownArrow = true;
    this.isLastNameSortCollapsedUpArrow = true;
    this.isLastNameSortCollapsedDownArrow = true;
    this.isAccessSortCollapsedUpArrow = true;
    this.isAccessSortCollapsedDownArrow = true;
    this.isUserNameSortCollapsedUpArrow = true;
    this.isUserNameSortCollapsedDownArrow = true;
    this.isStatusSortCollapsedUpArrow = true;
    this.isStatusSortCollapsedDownArrow = true;
    if (upDown) {
    this.sortArry = [];
    this.sortArry = this.pipe.transform(this.intialPurchaseOrderList, propertyName, true);
    console.log(this.sortArry[0].type);
    this.useradmindtolist = [];
    this.useradmindtolist = this.sortArry;
    this.isTypeSortCollapsedUpArrow = !this.isTypeSortCollapsedUpArrow;
    this.isTypeSortCollapsedDownArrow = true;
} else {
  this.sortArry = []; 
  this.sortArry = this.pipe.transform(this.intialPurchaseOrderList, propertyName, false);
  console.log(this.sortArry[0].type);
  this.useradmindtolist = [];
  this.useradmindtolist = this.sortArry;
  this.isTypeSortCollapsedDownArrow = !this.isTypeSortCollapsedDownArrow;
  this.isTypeSortCollapsedUpArrow = true;
} 
  }else if (propertyName === 'partnerName' ) {
    this.isFirstNameSortCollapsedUpArrow = true;
    this.isFirstNameSortCollapsedDownArrow = true;
    this.isLastNameSortCollapsedUpArrow = true;
    this.isLastNameSortCollapsedDownArrow = true;
    this.isTypeSortCollapsedUpArrow = true;
    this.isTypeSortCollapsedDownArrow = true;
    this.isUserNameSortCollapsedUpArrow = true;
    this.isUserNameSortCollapsedDownArrow = true;
    this.isStatusSortCollapsedUpArrow = true;
    this.isStatusSortCollapsedDownArrow = true;
    if (upDown) {
    this.sortArry = [];
    this.sortArry = this.pipe.transform(this.intialPurchaseOrderList, propertyName, true);
    console.log(this.sortArry[0].partnerName);
    this.useradmindtolist = [];
    this.useradmindtolist = this.sortArry;
    this.isAccessSortCollapsedUpArrow = !this.isAccessSortCollapsedUpArrow;
    this.isAccessSortCollapsedDownArrow = true;
} else {
  this.sortArry = []; 
  this.sortArry = this.pipe.transform(this.intialPurchaseOrderList, propertyName, false);
  console.log(this.sortArry[0].partnerName);
  this.useradmindtolist = [];
  this.useradmindtolist = this.sortArry;
  this.isAccessSortCollapsedDownArrow = !this.isAccessSortCollapsedDownArrow;
  this.isAccessSortCollapsedUpArrow = true;
} 
  }else if (propertyName === 'userName' ) {
    this.isFirstNameSortCollapsedUpArrow = true;
    this.isFirstNameSortCollapsedDownArrow = true;
    this.isLastNameSortCollapsedUpArrow = true;
    this.isLastNameSortCollapsedDownArrow = true;
    this.isTypeSortCollapsedUpArrow = true;
    this.isTypeSortCollapsedDownArrow = true;
    this.isAccessSortCollapsedUpArrow = true;
    this.isAccessSortCollapsedDownArrow = true;
    this.isStatusSortCollapsedUpArrow = true;
    this.isStatusSortCollapsedDownArrow = true;
    if (upDown) {
    this.sortArry = [];
    this.sortArry = this.pipe.transform(this.intialPurchaseOrderList, propertyName, true);
    console.log(this.sortArry[0].userName);
    this.useradmindtolist = [];
    this.useradmindtolist = this.sortArry;
    this.isUserNameSortCollapsedUpArrow = !this.isUserNameSortCollapsedUpArrow;
    this.isUserNameSortCollapsedDownArrow = true;
} else {
  this.sortArry = []; 
  this.sortArry = this.pipe.transform(this.intialPurchaseOrderList, propertyName, false);
  console.log(this.sortArry[0].userName);
  this.useradmindtolist = [];
  this.useradmindtolist = this.sortArry;
  this.isUserNameSortCollapsedDownArrow = !this.isUserNameSortCollapsedDownArrow;
  this.isUserNameSortCollapsedUpArrow = true;
} 
  }else if (propertyName === 'status' ) {
    this.isFirstNameSortCollapsedUpArrow = true;
    this.isFirstNameSortCollapsedDownArrow = true;
    this.isLastNameSortCollapsedUpArrow = true;
    this.isLastNameSortCollapsedDownArrow = true;
    this.isTypeSortCollapsedUpArrow = true;
    this.isTypeSortCollapsedDownArrow = true;
    this.isAccessSortCollapsedUpArrow = true;
    this.isAccessSortCollapsedDownArrow = true;
    this.isUserNameSortCollapsedUpArrow = true;
    this.isUserNameSortCollapsedDownArrow = true;
    if (upDown) {
    this.sortArry = [];
    this.sortArry = this.pipe.transform(this.intialPurchaseOrderList, propertyName, true);
    console.log(this.sortArry[0].status);
    this.useradmindtolist = [];
    this.useradmindtolist = this.sortArry;
    this.isStatusSortCollapsedUpArrow = !this.isStatusSortCollapsedUpArrow;
    this.isStatusSortCollapsedDownArrow = true;
} else {
  this.sortArry = []; 
  this.sortArry = this.pipe.transform(this.intialPurchaseOrderList, propertyName, false);
  console.log(this.sortArry[0].status);
  this.useradmindtolist = [];
  this.useradmindtolist = this.sortArry;
  this.isStatusSortCollapsedDownArrow = !this.isStatusSortCollapsedDownArrow;
  this.isStatusSortCollapsedUpArrow = true;
} 
  }
}

moveStoreToLeft(): void 
{
  let value = (<HTMLSelectElement>document.getElementById('leftPanel')).value;  
 // var response = value.substring(value.indexOf(":")+3, value.indexOf("-")-1);
  
  for(let j = 0; j < this.selectPartenerLocations.length; j++){
    var response = this.selectPartenerLocations[j].substring(this.selectPartenerLocations[j].indexOf(":")+1, this.selectPartenerLocations[j].indexOf("-")-1);
      for(let i = 0; i < this.data.length; i++)
      {         
        var dataLocCode = this.data[i].name;
        var dataCode = dataLocCode.substring(0, dataLocCode.indexOf("-")-1);
  
         if(dataCode === response)
         {       
           //this.selectedLocations.push({id:this.data[i].id, name:this.data[i].name});
           this.selectedlocations.push(this.data[i]);
         }
         else{
          //this.updateLocationList.push({id:this.data[i].id, name:this.data[i].name})
          this.updateLocationList.push(this.data[i])
         }
      }

      this.data = this.updateLocationList;
      this.updateLocationList = [];
   }  
      this.selectPartenerLocations = [];
 
}

moveStoreToRight(): void 
{
  let isLocationFoundInList = true;
  let value = (<HTMLSelectElement>document.getElementById('rightPanel')).value;
    
  for(let j = 0; j < this.selectPartenerLocations.length; j++){
  var response = this.selectPartenerLocations[j].substring(this.selectPartenerLocations[j].indexOf(":")+1, this.selectPartenerLocations[j].indexOf("-")-1);
  //var response = value.substring(value.indexOf(":")+3, value.length-1);
  //var response = value.substring(value.indexOf(":")+3, value.indexOf("-")-1);
  
  let selectedPartnerId :String="";

  for(let i = 0; i < this.selectedlocations.length; i++)
  {  
    var dataLocCode = this.selectedlocations[i].name;
    var dataCode = dataLocCode.substring(0, dataLocCode.indexOf("-")-1);      
    if(dataCode === response)
    {
      selectedPartnerId = this.selectedlocations[i].accessID;
      break;
    }
  }
  

  if(selectedPartnerId != this.access)
  {
    isLocationFoundInList = false;   
  }

  if(isLocationFoundInList)
  {   
    for(let i = 0; i < this.selectedlocations.length; i++)
    {
      var dataLocCode = this.selectedlocations[i].name;
      var dataCode = dataLocCode.substring(0, dataLocCode.indexOf("-")-1);      
     if(dataCode === response)
     {  
       this.data.push(this.selectedlocations[i]);
     }
     else{      
      this.updatedSelectedLocations.push(this.selectedlocations[i]);
     }
    }


  this.selectedlocations = this.updatedSelectedLocations;
  this.updatedSelectedLocations = [];
  }
  else
  {
    this.modalLocPopup = true;
  }
  }
}

getDistributorLocationDetails(){      
   
  this.data = [];    
  let isDetailFound : boolean=false;
  
  if(this.isSelectionListEmpty)
  {  
    this.selectedlocations = [];//remove all right side location
  }

  if(this.access=="" || this.access== null || this.access== undefined){
    console.log("this.access : " + this.access);
    this.data = [];
  }
  else
  {   
    this.loading=true;
    this.httpclientService.getDistributorLocationDetails(this.access,this.userId).subscribe(
      data =>{        
        this.data = data;        

        for(let i = 0; i < this.data.length; i++)
        {         
          if(this.data[i].status == 'Y')
          {         
            
            if(this.isSelectionListEmpty)
            {              
              this.selectedlocations.push(this.data[i]);
              this.selectedloc.push(this.data[i]);              
            } 
            else
            {
              if(this.selectedlocations.findIndex(item => item.name === this.data[i].name) == -1){
                this.selectedlocations.push(this.data[i]);
              }
              if(this.selectedloc.findIndex(item => item.name === this.data[i].name) == -1){
                this.selectedloc.push(this.data[i]);
              }
            }          
          }
          else
          {
            this.updateLocationList.push(this.data[i]);
          }         
        } 
        
        for(let i = 0; i < this.updateLocationList.length; i++)
        {
          isDetailFound = false;
         for(let j = 0; j < this.selectedlocations.length; j++)
         {
          if(this.selectedlocations[j].SupplierSoldToID == this.updateLocationList[i].SupplierSoldToID)
          {
            isDetailFound = true;
            break;
          }
         }
         if(!isDetailFound)
         {
          this.filterUpdateLocationList.push(this.updateLocationList[i]);
         }
        }
        
        this.data = this.filterUpdateLocationList;  
        this.previousLocationDataSize = this.data.length;
        this.updateLocationList = []; 
        this.filterUpdateLocationList = []; 
      }      
    )
    
    this.loading=false;
  } 
  
  
}

selectChangeHandler(event: any): void {  
    
  this.copyRoleList = this.roleList.filter(item => item.roleType == 'Distributor');
  
  if(this.roleId == this.copyRoleList[0].roleId)
  {    
    if(event.target.value === '')
    {
      this.isPayerSelectValFail = true; 
    }
    else
    {
      this.isPayerSelectValFail = false; 
    }
  } 
  

  this.isSelectionListEmpty = false;
  let curruntLocationDataSize = this.data.length;     
  this.selectedPayerToLoad = '';
  if(this.previousLocationDataSize === curruntLocationDataSize)
  {
    if(event.target.value === '')
    {     
      this.data = [];
      this.selectedlocations = this.data;    
    }
    else
    {   
      this.getDistributorLocationDetails();
    }
  }
  else
  {    
    this.locationModalPopup = true;
    this.selectedPayerToLoad = this.access;
    //Here we need to save the details as user add or move the locations left to right
    this.isSavedMovedLocation=true;
  }  
}

selectLocationChangeHandler(propertyName: string): void {   
  let curruntLocationDataSize = this.data.length;     
  this.selectedPayerToLoad = '';
  if(this.previousLocationDataSize === curruntLocationDataSize)
  {
    if(propertyName === '')
    {     
      this.data = [];
      this.selectedlocations = this.data;    
    }
    else
    {   
      this.getDistributorLocationDetails();
    }
  }
  else
  {    
    this.selectedPayerToLoad = this.access;
    //Here we need to save the details as user add or move the locations left to right
    this.isSavedMovedLocation=true;
  }  
}


selectAccessChangeFilter(event: any): void {    
  let selAcess = this.selectedAccess;
      
  this.filteredUseradmindtolist = this.useradmindtolist;

  this.selectedType = "";
  
  this.selectedStatus = "";

  if(selAcess != "")
  {     
   this.filteredUseradmindtolist = this.useradmindtolist.filter(item => item.partnerName == selAcess);
  }  

}

selectTypeChangeFilter(event: any): void {      
  this.seltype1 = this.selectedType;     
  let selType = this.selectedType; 
  
  this.selectedAccess = "";
  this.selectedStatus = "";

  this.filteredUseradmindtolist = this.useradmindtolist;
  if(selType != "")
  {   
     this.filteredUseradmindtolist = this.useradmindtolist.filter(item => item.type == selType);
  }

}

selectStatusChangeFilter(event: any): void {      
  let selStatus = this.selectedStatus;

  this.selectedType = "";
  this.selectedAccess = "";  

  this.filteredUseradmindtolist = this.useradmindtolist;
  if(selStatus != "")
  {    
   if(selStatus == "Active")
     this.filteredUseradmindtolist = this.useradmindtolist.filter(item => item.status == true);
   else
    this.filteredUseradmindtolist = this.useradmindtolist.filter(item => item.status == false);
  } 

}

}

class Role{
  public roleId : number;
  public roleType : string;
  constructor(
       roleId ,
       roleType 
  ){
      this.roleId=roleId;
      this.roleType=roleType;
  }

}
class Partner{
  public partnerId : number;
  public partnerType : string;

  constructor(
       partnerId ,
       partnerType ,
  ){
      this.partnerId=partnerId;
      this.partnerType=partnerType;
  }

}


